// Polyfill for CustomEvent() constructor functionality in Internet Explorer 9
(function () {
    if ( typeof window.CustomEvent === "function" ) return false;
    function CustomEvent ( event, params ) {
        params = params || { bubbles: false, cancelable: false, detail: null };
        var evt = document.createEvent( 'CustomEvent' );
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
        return evt;
    }
    window.CustomEvent = CustomEvent;
})();

(function () {
    // Polyfill for Object.assign (for IE);
    if (typeof Object.assign !== 'function') {
        // Must be writable: true, enumerable: false, configurable: true
        Object.defineProperty(Object, "assign", {
            value: function assign(target, varArgs) {
                'use strict';
                if (target == null) {
                    throw new TypeError('Cannot convert undefined or null to object');
                }
                var to = Object(target);
                for (var index = 1; index < arguments.length; index++) {
                    var nextSource = arguments[index];
                    if (nextSource != null) { // Skip over if undefined or null
                        for (var nextKey in nextSource) {
                            // Avoid bugs when hasOwnProperty is shadowed
                            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                                to[nextKey] = nextSource[nextKey];
                            }
                        }
                    }
                }
                return to;
            },
            writable: true,
            configurable: true
        });
    };

    // Polyfill for requestAnimationFrame;
    if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = function (callback) {
            return window.setTimeout(function () {
                callback(Date.now());
            }, 1000 / 60);
        };
    }

    if (!window.cancelAnimationFrame) {
        window.cancelAnimationFrame = function (id) {
            clearTimeout(id);
        };
    }

    // Polyfill for Element.closest
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            Element.prototype.msMatchesSelector ||
            Element.prototype.webkitMatchesSelector;
    }

    if (!Element.prototype.closest) {
        Element.prototype.closest = function(s) {
            var el = this;
            do {
                if (Element.prototype.matches.call(el, s)) return el;
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
        };
    }

    function forEachNode(nodeList, callback){
        for (var i=0;i<nodeList.length;i++) {
            callback(nodeList[i], i);
        }
    }

    function fadeIn(el, duration){
        var elIsHidden = getComputedStyle(el).display === 'none';
        if (!elIsHidden){
            return;
        }
        var originalOpacity = getComputedStyle(el).opacity;
        el.style.opacity = '0';
        el.style.transition = duration ? 'opacity ' + duration + 'ms' : 'opacity 0.3s';
        el.classList.remove('gwa-cpu-hidden');
        setTimeout(function (){
            el.style.opacity = originalOpacity === '0' ? '1' : originalOpacity;
            setTimeout(function (){
                el.style.transition = '';
                el.style.opacity = '';
            }, duration ? duration : 300);
        }, 5);
    }

    function fadeOut(el, duration){
        var elIsHidden = getComputedStyle(el).display === 'none';
        if (elIsHidden){
            return;
        }
        el.style.transition = duration ? 'opacity ' + duration + 'ms' : 'opacity 0.3s';
        el.style.opacity = '0';
        setTimeout(function (){
            el.classList.add('gwa-cpu-hidden');
            el.style.transition = '';
            el.style.opacity = '';
        }, duration ? duration : 300);
    }

    var tabHidden, visibilityChange;
    if (typeof document.hidden !== "undefined") {
        tabHidden = "hidden";
        visibilityChange = "visibilitychange";
    } else if (typeof document.msHidden !== "undefined") {
        tabHidden = "msHidden";
        visibilityChange = "msvisibilitychange";
    } else if (typeof document.webkitHidden !== "undefined") {
        tabHidden = "webkitHidden";
        visibilityChange = "webkitvisibilitychange";
    }

    var gwaCpu = {};
    var cpuWidgetInited = false;
    gwaCpu.selectors = {
        cpuSectionClass: 'gwa-cpu-widget-section',
        cpuWidget: '.gwa-cpu-widget',
        cpuGallery: '.gwa-cpu-gallery',
        cpuGallerySliderClass: 'gwa-cpu-gallery',
        cpuSliderInner: '.gwa-cpu-gallery-inner',
        cpuSliderTrack: '.gwa-cpu-gallery-track',
        cpuSliderTrackTransitioning: '.gwa-cpu-gallery-track-transitioning',
        cpuSliderTrackTransitioningClass: 'gwa-cpu-gallery-track-transitioning',
        cpuSlide: '.gwa-cpu-gallery-item',
        cpuSlideClass: 'gwa-cpu-gallery-item',
        cpuSlideImage: '.gwa-cpu-gallery-img',
        cpuSlideImageClass: 'gwa-cpu-gallery-img',
        cpuSlideClone: '.gwa-cpu-gallery-item-clone',
        cpuSlideCloneClass: 'gwa-cpu-gallery-item-clone',
        cpuSlideNotClone: '.gwa-cpu-gallery-item:not(.gwa-cpu-gallery-item-clone)',
        cpuSliderArrows: '.gwa-cpu-arrow',
        cpuSliderArrowsHiddenClass: 'gwa-cpu-arrow-hidden',
        cpuSliderArrowPrev: '.gwa-cpu-arrow-prev',
        cpuSliderArrowNext: '.gwa-cpu-arrow-next',
        cpuSliderDots: '.gwa-cpu-dots',
        cpuSliderDot: '.gwa-cpu-dot',
        cpuSliderDotActive: '.gwa-cpu-dot-active',
        cpuSliderDotClass: 'gwa-cpu-dot',
        cpuSliderDotActiveClass: 'gwa-cpu-dot-active',
        cpuLightbox: '.gwa-cpu-lightbox',
        cpuLightboxActiveClass: 'gwa-cpu-lightbox-active',
        cpuLightboxSlider: '.gwa-cpu-lightbox-slider',
        cpuLightboxZoomBtn: '.gwa-cpu-lightbox-zoom',
        cpuLightboxZoomInIcon: '.gwa-cpu-zoom-in',
        cpuLightboxZoomOutIcon: '.gwa-cpu-zoom-out',
        cpuImageZoomedClass: 'image-zoomed',
        cpuImageZoomed: '.image-zoomed',
        cpuImageZooming: '.image-zooming',
        cpuLightboxFullscreenBtn: '.gwa-cpu-lightbox-fullscreen',
        cpuLightboxFullscreenEnterIcon: '.gwa-cpu-fullscreen-enter',
        cpuLightboxFullscreenExitIcon: '.gwa-cpu-fullscreen-exit',
        cpuLightboxShareBtn: '.gwa-cpu-lightbox-share',
        cpuLightboxDownloadBtn: '.gwa-cpu-lightbox-download',
        cpuUploadBtn: '.gwa-cpu-widget-button',
        cpuUploadWidget: '.gwa-cpu-widget-upload',
        cpuUploadInner: '.gwa-cpu-modal-inner',
        cpuDropZone: '.gwa-cpu-drop-zone',
        cpuDropZoneContent: '.gwa-cpu-drop-zone-content',
        cpuUploadForm: '.gwa-cpu-form',
        cpuUploadSubmit: '.gwa-cpu-upload-submit',
        cpuUploadFile: '.gwa-cpu-upload-file',
        cpuUploadManual: '.gwa-cpu-upload-manually',
        cpuUploadCancel: '.gwa-cpu-upload-cancel',
        cpuUploadMore: '.gwa-cpu-upload-more',
        cpuProgressBar: '.gwa-cpu-progress-bar',
        cpuUploadError: '.gwa-cpu-error',
        cpuInputError: '.gwa-cpu-input-error',
        cpuUploadInputWrapper: '.gwa-cpu-form-field',
        cpuUploadInput: '.gwa-cpu-input',
        cpuUploadTextInput: '.gwa-cpu-input-text',
        cpuUploadNotifyCheckbox: '.gwa-cpu-input[name="formData[sendNotification]"]',
        cpuUploadEmailInput: '.gwa-cpu-input[name="formData[customerEmail]"]',
        cpuUploadDescriptionInput: '.gwa-cpu-input[name="formData[alt]"]',
        cpuTransformedContainer: '.page-container',
        cpuCloseModal: '.gwa-cpu-modal-close'
    };

    gwaCpu.Widget = (function(){
        function CpuWidget(widget){
            var _this = this;
            var cpuWidget = this.cpuWidget = widget;
            this.widgetData = JSON.parse(cpuWidget.getAttribute('data-cpu-data'));
            this.widgetSectionId = cpuWidget.getAttribute('data-cpu-section-id');

            this.settings = {
                galleryEnabled: this.cpuWidget.querySelector(gwaCpu.selectors.cpuSlider) !== 'undefined',
                lightboxEnabled: cpuWidget.querySelector(gwaCpu.selectors.cpuLightbox) !== 'undefined'
            };
            if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData) {
                this.settings.uploadBtnEnabled = cpuWidget.querySelector(gwaCpu.selectors.cpuUploadBtn) !== 'undefined';
            }
            else {
                this.settings.uploadBtnEnabled = false;
            }

            if (this.settings.galleryEnabled) {
                this.initGallery();
                if (this.settings.lightboxEnabled) {
                    this.initLightbox();
                }
            }

            if (this.settings.uploadBtnEnabled) {
                this.initUploadWidget();
            }

        };
        CpuWidget.prototype = Object.assign({}, CpuWidget.prototype,{
            initGallery: function () {
                var _this = this;
                this.cpuGallery = this.cpuWidget.querySelector(gwaCpu.selectors.cpuGallery);
                this.cpuGalleryImages = this.cpuWidget.querySelectorAll(gwaCpu.selectors.cpuSlideImage);
                if (this.cpuGallery.className.indexOf(gwaCpu.selectors.cpuGallerySliderClass) >= 0){
                    this.initGallerySlider();
                }
            },
            initGallerySlider: function (){
                var sliderSettings = JSON.parse(this.cpuGallery.getAttribute('data-cpu-slider-settings'));
                var sliderOptions = {
                    slidesToShow: sliderSettings.slides_to_show.desktop,
                    slidesToScroll: sliderSettings.slides_to_scroll_desktop,
                    rows: 1,
                    arrows: sliderSettings.arrows,
                    dots: sliderSettings.dots.desktop,
                    autoplay: sliderSettings.autoplay,
                    infinite: sliderSettings.infinite,
                    pauseOnHover: sliderSettings.pause_on_hover,
                    touchMove: sliderSettings.touch_move,
                    speed: sliderSettings.speed.desktop,
                    autoplaySpeed: sliderSettings.autoplay_speed,
                    responsive: {
                        960: {
                            slidesToShow: sliderSettings.slides_to_show.tablet,
                            slidesToScroll: sliderSettings.slides_to_scroll_tablet,
                            dots: sliderSettings.dots.tablet,
                            speed: sliderSettings.speed.tablet
                        },
                        480: {
                            slidesToShow: sliderSettings.slides_to_show.mobile,
                            slidesToScroll: sliderSettings.slides_to_scroll_mobile,
                            dots: sliderSettings.dots.mobile,
                            speed: sliderSettings.speed.mobile
                        }
                    }
                }
                var cpuSlider = new gwaCpu.Slider(this.cpuGallery, sliderOptions, this.cpuGalleryImages);
            },
            initLightbox: function () {
                var _this = this;
                var lightBox = this.cpuWidget.querySelector(gwaCpu.selectors.cpuLightbox);
                var lightBoxSlider = lightBox.querySelector(gwaCpu.selectors.cpuLightboxSlider);
                var lightBoxSliderTrack = lightBox.querySelector(gwaCpu.selectors.cpuSliderTrack);
                var touchData = {clientY: 0, clientX: 0};
                var touchStarted = false;
                var touchDataZoom = {transformX: 0, transformY: 0, clientY: 0, clientX: 0};
                var closeButton = lightBox.querySelector(gwaCpu.selectors.cpuCloseModal);
                var zoomButton = lightBox.querySelector(gwaCpu.selectors.cpuLightboxZoomBtn);
                var zoomInIcon = lightBox.querySelector(gwaCpu.selectors.cpuLightboxZoomInIcon);
                var zoomOutIcon = lightBox.querySelector(gwaCpu.selectors.cpuLightboxZoomOutIcon);
                var maxZoom = 4;
                var fullscreenButton = lightBox.querySelector(gwaCpu.selectors.cpuLightboxFullscreenBtn);
                var fullscreenEnterIcon = lightBox.querySelector(gwaCpu.selectors.cpuLightboxFullscreenEnterIcon);
                var fullscreenExitIcon = lightBox.querySelector(gwaCpu.selectors.cpuLightboxFullscreenExitIcon);
                var shareBtn = lightBox.querySelector(gwaCpu.selectors.cpuLightboxShareBtn);
                var downloadBtn = lightBox.querySelector(gwaCpu.selectors.cpuLightboxDownloadBtn);
                var lightBoxSettings = JSON.parse(lightBox.getAttribute('data-settings'));
                var lightBoxSliderCreated = false;
                var lightBoxSliderObj;

                var sliderOptions = {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true,
                    autoplay: false,
                    infinite: true,
                    touchMove: true
                }

                openLightBoxOnClick();

                if (lightBoxSettings.zoom) {
                    initZoomInLightBox();
                }

                closeButton.addEventListener('click', closeLightBox);

                zoomButton.addEventListener('click', function (){
                    var image = lightBoxSlider.querySelector(gwaCpu.selectors.cpuSlide + '[data-item-index="' + lightBoxSliderObj.currentSlideIndex + '"] ' + gwaCpu.selectors.cpuSlideImage);
                    toggleZoom(image);
                });

                if (!document.documentElement.requestFullscreen && !document.documentElement.mozRequestFullscreen && !document.documentElement.msRequestFullscreen && !document.documentElement.webkitRequestFullscreen) {
                    fullscreenButton.style.display = 'none';
                }
                fullscreenButton.addEventListener('click', function () {
                    if (!document.fullscreenElement && !document.mozFullscreenElement && !document.msFullscreenElement && !document.webkitFullscreenElement) {
                        if (document.documentElement.requestFullscreen){
                            document.documentElement.requestFullscreen();
                        }
                        else if (document.documentElement.mozRequestFullscreen){
                            document.documentElement.mozRequestFullscreen();
                        }
                        else if (document.documentElement.msRequestFullscreen){
                            document.documentElement.msRequestFullscreen();
                        }
                        else if (document.documentElement.webkitRequestFullscreen){
                            document.documentElement.webkitRequestFullscreen();
                        }

                    } else {
                        if (document.exitFullscreen) {
                            document.exitFullscreen();
                        }
                        else if (document.mozExitFullscreen){
                            document.mozExitFullscreen();
                        }
                        else if (document.msExitFullscreen){
                            document.msExitFullscreen();
                        }
                        else if (document.webkitExitFullscreen){
                            document.webkitExitFullscreen();
                        }
                    }
                });

                lightBoxSlider.addEventListener('cpuSliderAfterChange', function (e) {
                    var zoomedImage = lightBoxSlider.querySelector(gwaCpu.selectors.cpuImageZoomed);
                    if (zoomedImage) {
                        toggleZoom(zoomedImage);
                    }
                });

                if (!navigator.canShare) {
                    shareBtn.style.display = 'none';
                }
                else {
                    var testFile = new File([""], "", {type: 'image/jpeg'});
                    if (!navigator.canShare({ files: [testFile] })){
                        shareBtn.style.display = 'none';
                    }
                }
                shareBtn.addEventListener('click', function(){
                    var currentImage = lightBoxSlider.querySelector(gwaCpu.selectors.cpuSlide + '[data-item-index="' + lightBoxSliderObj.currentSlideIndex + '"] ' + gwaCpu.selectors.cpuSlideImage);
                    share(currentImage);
                });

                downloadBtn.addEventListener('click', function(){
                    var currentImage = lightBoxSlider.querySelector(gwaCpu.selectors.cpuSlide + '[data-item-index="' + lightBoxSliderObj.currentSlideIndex + '"] ' + gwaCpu.selectors.cpuSlideImage);
                    var imageUrl = currentImage.getAttribute('src');
                    var urlParts = imageUrl.toString().split('/');
                    var filename = urlParts[urlParts.length - 1].split('?')[0];
                    var req = new XMLHttpRequest();
                    req.open('get', imageUrl);
                    req.setRequestHeader('Accept', 'image/jpeg');
                    req.setRequestHeader('Accept', 'image/png');
                    req.setRequestHeader('Accept', 'image/gif');
                    req.responseType = "blob";
                    req.onreadystatechange = function (data) {
                        if(req.readyState === XMLHttpRequest.DONE && req.status === 200) {
                            var newBlob = data.target.response;
                            var objectURL = URL.createObjectURL(newBlob);
                            if (typeof window.navigator.msSaveBlob !== 'undefined') {
                                window.navigator.msSaveBlob(newBlob, filename);
                            }
                            else {
                                var anchor = document.createElement('a');
                                anchor.style.display = 'none';
                                anchor.href = objectURL;
                                anchor.download = filename;
                                anchor.click();
                            }
                        }
                    };
                    req.send();
                });

                document.addEventListener('fullscreenchange', function(){
                    if (!document.fullscreenElement) {
                        fullscreenExitIcon.style.display = 'none';
                        fullscreenEnterIcon.style.display = 'inline';
                    } else {
                        fullscreenEnterIcon.style.display = 'none';
                        fullscreenExitIcon.style.display = 'inline';
                    }
                });

                document.addEventListener('keyup', function(e){
                    if (lightBox.className.indexOf(gwaCpu.selectors.cpuLightboxActiveClass) < 0) {
                        return;
                    }
                    if (e.code === 'ArrowRight'){
                        lightBoxSliderObj.goToNextSlide();
                    }
                    else if (e.code === 'ArrowLeft'){
                        lightBoxSliderObj.goToPrevSlide();
                    }
                    else if (e.code === 'Escape') {
                        closeLightBox();
                    }
                });

                function openLightBoxOnClick(){
                    var startHandler = function (e) {
                        if (e.type === 'mousedown' && e.button !== 0){
                            return;
                        }
                        if (e.target.className.indexOf(gwaCpu.selectors.cpuSlideImageClass) < 0){
                            return;
                        }
                        if (touchStarted) {
                            return;
                        }
                        e.preventDefault();
                        touchStarted = true;
                        touchData = {
                            clientX: e.type === 'touchstart' ? e.touches[0].clientX : e.clientX,
                            clientY: e.type === 'touchstart' ? e.touches[0].clientY : e.clientY
                        };
                        _this.cpuGallery.addEventListener('mouseup', endHandler);
                        _this.cpuGallery.addEventListener('touchend', endHandler);
                    };
                    var endHandler = function (e) {
                        var distanceX = (e.type === 'touchend' ? e.changedTouches[0].clientX : e.clientX) - touchData.clientX;
                        var distanceY = (e.type === 'touchend' ? e.changedTouches[0].clientY : e.clientY) - touchData.clientY;
                        if (distanceX === 0 && distanceY === 0){
                            if (!lightBoxSliderCreated) {
                                createLightbox();
                            }
                            var slideIndex = +e.target.getAttribute('data-image-index');
                            var inLightBoxSlide = lightBox.querySelector(gwaCpu.selectors.cpuSlideNotClone + '[data-item-index-original="'+slideIndex+'"]');
                            var inLightBoxSlideIndex = +inLightBoxSlide.getAttribute('data-item-index');
                            fadeIn(lightBox);
                            lightBox.classList.add(gwaCpu.selectors.cpuLightboxActiveClass);
                            lightBoxSliderObj.currentSlideIndexOriginal = slideIndex;
                            lightBoxSliderObj.currentSlideIndex = inLightBoxSlideIndex;
                            lightBoxSliderObj.initSlider();
                        }
                        _this.cpuGallery.removeEventListener('mouseup', endHandler);
                        _this.cpuGallery.removeEventListener('touchend', endHandler);
                        touchStarted = false;
                    };

                    _this.cpuGallery.addEventListener('mousedown', startHandler);
                    _this.cpuGallery.addEventListener('touchstart', startHandler);
                };

                function createLightbox(){
                    forEachNode(_this.cpuGalleryImages, function(cpuGalleryImage, i){
                        var lightBoxSlide = document.createElement('div');
                        var lightBoxSlideImg = document.createElement('img');
                        var fullSizeSrc = cpuGalleryImage.getAttribute('data-full-image-src');
                        lightBoxSlide.classList.add(gwaCpu.selectors.cpuSlideClass);
                        lightBoxSlide.setAttribute('data-item-index', i);
                        lightBoxSlide.setAttribute('data-item-index-original', i);
                        lightBoxSlideImg.classList.add(gwaCpu.selectors.cpuSlideImageClass);
                        lightBoxSlideImg.setAttribute('src', fullSizeSrc);
                        lightBoxSlideImg.setAttribute('data-image-index', i);
                        lightBoxSlideImg.style.transform = 'translate(0,0)';
                        lightBoxSlide.appendChild(lightBoxSlideImg);
                        lightBoxSliderTrack.appendChild(lightBoxSlide);
                    });

                    document.body.appendChild(lightBox);

                    lightBoxSliderObj = new gwaCpu.Slider(lightBoxSlider, sliderOptions);
                    lightBoxSliderCreated = true;
                };

                function initZoomInLightBox(){
                    var startHandlerZoom = function (e) {
                        if (e.type === 'mousedown' && e.button !== 0){
                            return;
                        }
                        if (e.target.className.indexOf(gwaCpu.selectors.cpuSlideImageClass) < 0 || e.target.className.indexOf(gwaCpu.selectors.cpuImageZooming) >=0){
                            return;
                        }
                        e.preventDefault();
                        var currentTransformX = +(getComputedStyle(e.target).transform.split(',')[4].trim());
                        var currentTransformY = +(getComputedStyle(e.target).transform.split(',')[5].replace(')','').trim());
                        var currentZoom = +(getComputedStyle(e.target).transform.split(',')[0].replace('matrix(', ''));
                        touchDataZoom = {
                            transformX: currentTransformX,
                            transformY: currentTransformY,
                            clientX: e.type === 'touchstart' ? e.touches[0].clientX : e.clientX,
                            clientY: e.type === 'touchstart' ? e.touches[0].clientY : e.clientY,
                            imgBoundingClientRect: e.target.getBoundingClientRect(),
                            slideBoundingClientRect: e.target.closest(gwaCpu.selectors.cpuSlide).getBoundingClientRect(),
                            currentZoom: currentZoom
                        };

                        if (e.target.className.indexOf(gwaCpu.selectors.cpuImageZoomedClass) >= 0){
                            lightBoxSlider.addEventListener('mousemove', moveHandlerZoom);
                            lightBoxSlider.addEventListener('touchmove', moveHandlerZoom);
                            lightBoxSlider.addEventListener('mouseleave', endHandlerZoom);
                        }
                        lightBoxSlider.addEventListener('mouseup', endHandlerZoom);
                        lightBoxSlider.addEventListener('touchend', endHandlerZoom);
                    };
                    var moveHandlerZoom = function (e) {
                        if (e.target.className.indexOf(gwaCpu.selectors.cpuImageZoomedClass) < 0){
                            return;
                        }
                        e.preventDefault();

                        var distanceX = (e.type === 'touchmove' ? e.touches[0].clientX : e.clientX) - touchDataZoom.clientX;
                        var distanceY = (e.type === 'touchmove' ? e.touches[0].clientY : e.clientY) - touchDataZoom.clientY;
                        var transformX = touchDataZoom.transformX + distanceX;
                        var transformY = touchDataZoom.transformY + distanceY;
                        var maxTransformX = (touchDataZoom.imgBoundingClientRect.width - touchDataZoom.slideBoundingClientRect.width)/2;
                        var maxTransformY = (touchDataZoom.imgBoundingClientRect.height - touchDataZoom.slideBoundingClientRect.height)/2;
                        if (Math.abs(transformX) > maxTransformX){
                            transformX = maxTransformX > 0 ? (transformX > 0 ? maxTransformX : maxTransformX*-1) : 0;
                        }
                        if (Math.abs(transformY) > maxTransformY){
                            transformY = maxTransformY > 0 ? (transformY > 0 ? maxTransformY : maxTransformY*-1) : 0;
                        }
                        e.target.style.transform = 'translate(' + transformX + 'px, ' + transformY + 'px) scale('+touchDataZoom.currentZoom+')';
                    };
                    var endHandlerZoom = function (e) {
                        var distanceX = (e.type === 'touchend' ? e.changedTouches[0].clientX : e.clientX) - touchDataZoom.clientX;
                        var distanceY = (e.type === 'touchend' ? e.changedTouches[0].clientY : e.clientY) - touchDataZoom.clientY;
                        if (distanceX === 0 && distanceY === 0){
                            toggleZoom(e.target);
                        }

                        lightBoxSlider.removeEventListener('mousemove', moveHandlerZoom);
                        lightBoxSlider.removeEventListener('touchmove', moveHandlerZoom);
                        lightBoxSlider.removeEventListener('mouseup', endHandlerZoom);
                        lightBoxSlider.removeEventListener('touchend', endHandlerZoom);
                    };

                    lightBoxSlider.addEventListener('mousedown', startHandlerZoom);
                    lightBoxSlider.addEventListener('touchstart', startHandlerZoom);
                };

                function toggleZoom(image){
                    if (image.className.indexOf(gwaCpu.selectors.cpuImageZoomedClass) >= 0){
                        image.classList.remove(gwaCpu.selectors.cpuImageZoomedClass);
                        image.classList.add(gwaCpu.selectors.cpuImageZooming);
                        image.style.cssText = 'transform: translate(0px,0px) scale(1);';
                        zoomOutIcon.style.display = 'none';
                        zoomInIcon.style.display = 'inline';
                        setTimeout(function (){
                            image.classList.remove(gwaCpu.selectors.cpuImageZooming);
                        },350);
                        return;
                    }

                    var imgFullWidth = image.naturalWidth;
                    var imgFullHeight = image.naturalHeight;
                    var imgWidth = image.getBoundingClientRect().width;
                    var imgHeight = image.getBoundingClientRect().height;

                    if (imgFullHeight > imgHeight || imgFullWidth > imgWidth){
                        var thisZoom = Math.min(maxZoom, imgFullWidth/imgWidth);
                        var zoomWidth = imgWidth * thisZoom;
                        var zoomHeight = imgHeight * thisZoom;
                        var slide = image.closest(gwaCpu.selectors.cpuSlide);
                        var slideWidth = slide.getBoundingClientRect().width;
                        var slideHeight = slide.getBoundingClientRect().height;
                        var screenCenterX = window.innerWidth/2;
                        var screenCenterY = window.innerHeight/2;
                        var transformX = 0;
                        var transformY = 0;
                        var maxTransformX = (zoomWidth - slideWidth)/2;
                        var maxTransformY = (zoomHeight - slideHeight)/2;

                        if (zoomWidth > slideWidth){
                            transformX = (screenCenterX - touchDataZoom.clientX)*thisZoom;
                            if (Math.abs(transformX) > maxTransformX){
                                transformX = transformX > 0 ? maxTransformX : maxTransformX*-1;
                            }
                        }
                        if (zoomHeight > slideHeight){
                            transformY = (screenCenterY - touchDataZoom.clientY)*thisZoom;
                            if (Math.abs(transformY) > maxTransformY){
                                transformY = transformY > 0 ? maxTransformY : maxTransformY*-1;
                            }
                        }

                        image.style.cssText = 'transform: translate(' + transformX + 'px, ' + transformY + 'px) scale('+thisZoom+');';
                        zoomInIcon.style.display = 'none';
                        zoomOutIcon.style.display = 'inline';
                        image.classList.add(gwaCpu.selectors.cpuImageZooming);
                        setTimeout(function (){
                            image.classList.add(gwaCpu.selectors.cpuImageZoomedClass);
                            image.classList.remove(gwaCpu.selectors.cpuImageZooming);
                        },350);
                    }
                };

                function closeLightBox(){
                    fadeOut(lightBox);
                    lightBox.classList.remove(gwaCpu.selectors.cpuLightboxActiveClass);
                    var zoomedImage = lightBoxSlider.querySelector(gwaCpu.selectors.cpuImageZoomed);
                    if (zoomedImage) {
                        toggleZoom(zoomedImage);
                    }
                    if (document.fullscreenElement) {
                        document.exitFullscreen();
                    }
                };

                function share(image) {
                    var imageUrl = image.getAttribute('src');
                    var urlParts = imageUrl.toString().split('/');
                    var filename = urlParts[urlParts.length - 1].split('?')[0];
                    var req = new XMLHttpRequest();
                    req.open('get', imageUrl);
                    req.setRequestHeader('Accept', 'image/jpeg');
                    req.setRequestHeader('Accept', 'image/png');
                    req.setRequestHeader('Accept', 'image/gif');
                    req.responseType = "blob";
                    req.onreadystatechange = function (data) {
                        if(req.readyState === XMLHttpRequest.DONE && req.status === 200) {
                            var newBlob = data.target.response;
                            var imgFile = new File([newBlob], filename, {type:newBlob.type});
                            if (navigator.canShare && navigator.canShare({ files: [imgFile] })) {
                                navigator.share({
                                    files: [imgFile],
                                    title: 'Pictures',
                                    text: 'Our Pictures.',
                                });
                            } else {
                                console.log(`Your system doesn't support sharing files.`);
                            }
                        }
                    };
                    req.send();
                }

            },
            initUploadWidget: function() {
                var _this = this,
                    uploadBtn = this.cpuWidget.querySelector(gwaCpu.selectors.cpuUploadBtn),
                    uploadWidget = this.cpuWidget.querySelector(gwaCpu.selectors.cpuUploadWidget),
                    uploadInner = this.cpuWidget.querySelector(gwaCpu.selectors.cpuUploadInner),
                    uploadDropZone = this.cpuWidget.querySelector(gwaCpu.selectors.cpuDropZone),
                    uploadDropZoneContent = this.cpuWidget.querySelector(gwaCpu.selectors.cpuDropZoneContent),
                    uploadForm = this.cpuWidget.querySelector(gwaCpu.selectors.cpuUploadForm),
                    uploadFile = this.cpuWidget.querySelector(gwaCpu.selectors.cpuUploadFile),
                    uploadManual = this.cpuWidget.querySelectorAll(gwaCpu.selectors.cpuUploadManual),
                    uploadMore = this.cpuWidget.querySelector(gwaCpu.selectors.cpuUploadMore),
                    uploadCancel = this.cpuWidget.querySelector(gwaCpu.selectors.cpuUploadCancel),
                    uploadSubmit = this.cpuWidget.querySelector(gwaCpu.selectors.cpuUploadSubmit),
                    uploadProgressBar = this.cpuWidget.querySelector(gwaCpu.selectors.cpuProgressBar),
                    uploadError = this.cpuWidget.querySelector(gwaCpu.selectors.cpuUploadError),
                    transformedContainer = document.querySelector(gwaCpu.selectors.cpuTransformedContainer),
                    uploadInputs = this.cpuWidget.querySelectorAll(gwaCpu.selectors.cpuUploadInput),
                    uploadTextInputs = this.cpuWidget.querySelectorAll(gwaCpu.selectors.cpuUploadTextInput),
                    uploadNotifyCheckbox = this.cpuWidget.querySelector(gwaCpu.selectors.cpuUploadNotifyCheckbox),
                    uploadEmailInput = this.cpuWidget.querySelector(gwaCpu.selectors.cpuUploadEmailInput),
                    uploadDescriptionInput = this.cpuWidget.querySelector(gwaCpu.selectors.cpuUploadDescriptionInput),
                    formInputsNum = uploadInputs.length,
                    currentFile,
                    uploadWidgetSettings = {
                        formEnabled: uploadWidget.getAttribute('data-widget-form') === 'true',
                        maxImageSize: 10485760,
                        acceptedTypes: ['image/gif', 'image/jpeg', 'image/png'],
                        fileErrors: {
                            sizeError: "Too large file upload attempt. Max allowed file size: 10MB.",
                            typeError: "Disallowed image type. You can upload only JPG, GIF or PNG images.",
                            fileNumError: "You can upload only one image",
                            noFileError: "No files selected"
                        },
                        formErrors: {
                            emailError: "Please enter a valid email address",
                            emptyError: "This field is required",
                            unknownError: "Something went wrong"
                        }
                    };

                if (getComputedStyle(transformedContainer).transform !== 'none' && transformedContainer.style.transform !== 'none') {
                    transformedContainer.style.transform = 'none';
                }

                document.body.appendChild(uploadWidget);

                attachFormListeners();
                attachDropzoneListeners();

                function attachDropzoneListeners() {
                    uploadBtn.addEventListener('click', function (e) {
                        fadeIn(uploadWidget);
                    });

                    uploadCancel.addEventListener('click', function (e) {
                        fadeOut(uploadWidget);
                        resetUploadWidget();
                    });

                    uploadWidget.addEventListener('click', function (e) {
                        if (e.target === this || e.target === this.firstElementChild) {
                            fadeOut(uploadWidget);
                            resetUploadWidget();
                        }
                    });

                    forEachNode(uploadManual, function (el){
                        el.addEventListener('click', function(e){
                            e.preventDefault();
                            uploadWidget.removeAttribute('data-file-type');
                            uploadFile.click();
                        });
                    });

                    uploadMore.addEventListener('click', resetUploadWidget);

                    uploadFile.addEventListener('change', function(e) {
                        if (this.files.length) {
                            showImagePreview(this.files);
                        }
                    });

                    uploadInner.addEventListener('click', function(){
                        if (currentFile) {
                            uploadWidget.removeAttribute('data-error');
                        }
                    });

                    uploadWidget.addEventListener('dragover', dragOverHandler);
                    uploadWidget.addEventListener("dragleave", dragLeaveHandler);
                    uploadWidget.addEventListener('drop', dropHandler);
                }

                function showImagePreview(filesObj) {
                    if (imageFileValidate(filesObj)) {
                        var imageFile = filesObj[0];
                        currentFile = imageFile;
                        uploadFile.files = filesObj;
                        var imgElem = document.createElement("img");
                        var imgSrc = window.URL.createObjectURL(imageFile);
                        imgElem.onload = function(e) {
                            uploadDropZone.style['background-image'] = 'url("'+ imgSrc +'")';
                            if (uploadWidgetSettings.formEnabled){
                                uploadWidget.setAttribute('data-stage', 'fill_form');
                                formValidate(false);
                            }
                            else {
                                uploadWidget.setAttribute('data-stage', 'confirm');
                                uploadSubmit.classList.remove('gwa-cpu-disabled');
                            }
                        };
                        imgElem.src = imgSrc;
                    }
                };

                function imageFileValidate(filesObj) {
                    uploadWidget.removeAttribute('data-error');
                    var errorText;
                    if (!filesObj.length){
                        return;
                    }
                    else if (filesObj.length > 1){
                        errorText = uploadWidgetSettings.fileErrors.fileNumError;
                    }
                    else {
                        var imageFile = filesObj[0];
                        if (uploadWidgetSettings.acceptedTypes.indexOf(imageFile.type) === -1) {
                            errorText = uploadWidgetSettings.fileErrors.typeError;
                        }
                        else if (imageFile.size > uploadWidgetSettings.maxImageSize) {
                            errorText = uploadWidgetSettings.fileErrors.sizeError;
                        }
                        else {
                            return true;
                        }
                    }
                    uploadError.innerText = errorText;
                    uploadWidget.setAttribute('data-error', 'true');
                    uploadFile.value = null;
                    return false;
                };

                function resetUploadWidget(){
                    uploadWidget.setAttribute('data-stage', 'load_image');
                    uploadWidget.removeAttribute('data-file-type');
                    uploadWidget.removeAttribute('data-error');
                    uploadWidget.removeAttribute('data-dragging');
                    uploadDropZone.style['background-image'] = 'none';
                    uploadDropZoneContent.style['background-color'] = 'rgba(255, 255, 255, 0.85)';
                    uploadProgressBar.style.background = 'white';
                    currentFile = null;
                    uploadFile.value = null;
                    uploadDescriptionInput.value = null;
                };

                function dropHandler(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    uploadWidget.removeAttribute('data-dragging');
                    uploadWidget.removeAttribute('data-error');
                    uploadFile.value = null;
                    showImagePreview(e.dataTransfer.files);
                };

                function dragOverHandler(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    if (uploadWidget.getAttribute('data-dragging') === 'true') return;
                    uploadWidget.removeAttribute('data-error');
                    uploadWidget.setAttribute('data-dragging', 'true');
                    var errorText;
                    var draggedFiles = e.dataTransfer ? e.dataTransfer.items : false;
                    if (draggedFiles && draggedFiles.length) {
                        if (draggedFiles.length > 1 && draggedFiles[0].type.indexOf('image/') >= 0) {
                            errorText = uploadWidgetSettings.fileErrors.fileNumError;
                        }
                        else if (uploadWidgetSettings.acceptedTypes.indexOf(draggedFiles[0].type) === -1) {
                            errorText = uploadWidgetSettings.fileErrors.typeError;
                        }
                        if (errorText) {
                            e.dataTransfer.dropEffect = "none";
                            uploadError.innerText = errorText;
                            uploadWidget.setAttribute('data-error', 'true');
                        }
                        else {
                            e.dataTransfer.dropEffect = "copy";
                            uploadWidget.setAttribute('data-file-type', draggedFiles[0].type);
                        }
                    }
                };

                function dragLeaveHandler(e){
                    e.preventDefault();
                    e.stopPropagation();
                    if (e.target.getAttribute('data-dragging') === 'true') {
                        e.dataTransfer.dropEffect = "none";
                        uploadWidget.removeAttribute('data-dragging');
                        uploadWidget.removeAttribute('data-error');
                        uploadWidget.removeAttribute('data-file-type');
                    }
                    else {
                        return;
                    }
                };

                function attachFormListeners(){
                    if (uploadWidgetSettings.formEnabled){
                        if (uploadTextInputs.length){
                            forEachNode(uploadTextInputs, function(el){
                                el.addEventListener('blur', function(){
                                    inputValidate(el, true);
                                });
                            });

                            forEachNode(uploadTextInputs, function(el){
                                el.addEventListener('focus', function(){
                                    el.closest('.gwa-cpu-form-field').classList.remove('gwa-cpu-field-error');
                                });
                            });
                        }

                        if (uploadNotifyCheckbox){
                            uploadNotifyCheckbox.addEventListener('change', function(){
                                if (this.checked) {
                                    uploadEmailInput.setAttribute('data-required', 'true');
                                }
                                else {
                                    uploadEmailInput.removeAttribute('data-required');
                                }
                                inputValidate(uploadEmailInput, true);
                            });
                        }

                        if (uploadInputs.length){
                            forEachNode(uploadInputs, function(el){
                                el.addEventListener('change', function () {
                                    formValidate(false);
                                });
                                el.addEventListener('keyup', function () {
                                    formValidate(false);
                                });
                            });
                        }
                    }

                    uploadForm.addEventListener('submit', function(e){
                        e.preventDefault();
                        submitUploadForm(this);
                    });

                    uploadForm.addEventListener('keydown', function(e){
                        if(e.keyCode == 13) {
                            if (!formValidate(false)){
                                e.preventDefault();
                                return false;
                            }
                        }
                    });
                }

                function formValidate(showResult) {
                    if (!uploadWidgetSettings.formEnabled){
                        return true;
                    }
                    var validatedNum = 0;
                    uploadInputs = _this.cpuWidget.querySelectorAll(gwaCpu.selectors.cpuUploadInput);
                    forEachNode(uploadInputs, function(el){
                        if (inputValidate(el, showResult)) {
                            validatedNum++;
                        }
                    });

                    if (validatedNum == formInputsNum) {
                        uploadSubmit.classList.remove('gwa-cpu-disabled');
                        return true;
                    }
                    else {
                        uploadSubmit.classList.add('gwa-cpu-disabled');
                        return false;
                    }
                }

                function inputValidate(input, showResult){
                    var inputType = input.getAttribute('type');
                    var inputWrap = input.closest('.gwa-cpu-form-field');
                    var inputError = inputWrap.querySelector('.gwa-cpu-input-error-text');
                    var validStatus;
                    if (inputType == 'email' || inputType == 'text') {
                        validStatus = textInputValidate(input);
                    }
                    else if (inputType == 'checkbox'){
                        validStatus = checkboxValidate(input);
                        if (validStatus.valid) {
                            inputWrap.classList.remove('gwa-cpu-field-error');
                        }
                    }
                    if (showResult) {
                        if (validStatus.valid){
                            inputWrap.classList.remove('gwa-cpu-field-error');
                            inputWrap.classList.add('gwa-cpu-field-valid');
                        }
                        else {
                            inputError.innerText = validStatus.error;
                            inputWrap.classList.remove('gwa-cpu-field-valid');
                            inputWrap.classList.add('gwa-cpu-field-error');
                        }
                    }
                    return validStatus.valid;
                }

                function textInputValidate(input) {
                    var inputVal = input.value.trim();
                    var errorText;
                    var required = input.hasAttribute('data-required') ? true : input.hasAttribute('required');
                    if (required && !inputVal.length) {
                        errorText = uploadWidgetSettings.formErrors.emptyError;
                    }
                    else if (inputVal.length && input.getAttribute('type') == 'email') {
                        if (!emailValidate(input.value)) {
                            errorText = uploadWidgetSettings.formErrors.emailError;
                        };
                    }
                    if (errorText) {
                        return {valid:false, error: errorText};
                    }
                    else {
                        return {valid:true};
                    }
                }

                function checkboxValidate(input) {
                    var errorText;
                    var required = input.hasAttribute('required');
                    if (required && !input.checked){
                        errorText = uploadWidgetSettings.formErrors.emptyError;
                        return {valid:false, error: errorText};
                    }
                    else {
                        return {valid:true};
                    }
                }

                function emailValidate(email){
                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return re.test(email);
                }

                function showLoadProgress(evt){
                    var progressComplete = evt.loaded / evt.total;
                    var percentComplete = progressComplete * 100;
                    uploadDropZoneContent.style['background-color'] = 'rgba(255, 255, 255, ' + (0.85 - (progressComplete * 0.5)) + ')';
                    uploadProgressBar.style.background ='linear-gradient(90deg, #5c6ac4, #5c6ac4 ' + percentComplete * 0.9 + '%, white ' + percentComplete * 0.9 + '%, white)';
                };

                function submitUploadForm(form){
                    if (!formValidate(true)){
                        return;
                    }
                    uploadWidget.setAttribute('data-stage', 'uploading');
                    uploadWidget.removeAttribute('data-error');
                    var formData = new FormData(form);
                    if (!uploadFile.files.length) {
                        if (currentFile) {
                            formData.append('image', currentFile);
                        }
                        else {
                            uploadError.innerText = uploadWidgetSettings.fileErrors.noFileError;
                            uploadWidget.setAttribute('data-stage', 'fill_form');
                            uploadWidget.setAttribute('data-error', 'true');
                            return;
                        }
                    }

                    var cpuReq = new XMLHttpRequest();
                    cpuReq.upload.addEventListener("progress", function(evt) {
                        if (evt.lengthComputable) {
                            showLoadProgress(evt);
                        }}, false);

                    cpuReq.open('POST', '/apps/gwa-cpu-preprod/upload');

                    cpuReq.onreadystatechange = function () {
                        if(cpuReq.readyState === XMLHttpRequest.DONE) {
                            var status = cpuReq.status;
                            if (status === 0 || status === 200) {
                                cpuReqOnSuccess()
                            } else {
                                cpuReqOnError(cpuReq);
                            }
                        }
                    };

                    cpuReq.send(formData);

                    function isJsonString(str) {
                        try {
                            JSON.parse(str);
                        } catch (e) {
                            return false;
                        }
                        return true;
                    };
                    function cpuReqOnSuccess() {
                        uploadWidget.setAttribute('data-stage', 'uploaded');
                    };
                    function cpuReqOnError(req) {
                        var inputWrappers = _this.cpuWidget.querySelectorAll(gwaCpu.selectors.cpuUploadInputWrapper);
                        forEachNode(inputWrappers, function (el) {
                            el.classList.remove('gwa-cpu-field-error');
                        });
                        uploadError.innerText = '';
                        if (req.response && isJsonString(req.response) && JSON.parse(req.response).errors) {
                            var errors = JSON.parse(req.response).errors;
                            for (var error in errors) {
                                var input = _this.cpuWidget.querySelector('input[name="formData[' + error + ']"]');
                                if (input){
                                    var inputWrap = input.closest('.gwa-cpu-form-field');
                                    var inputError = inputWrap.querySelector('.gwa-cpu-input-error-text');
                                    inputError.innerText = errors[error].fieldErrors[0];
                                    inputWrap.classList.remove('gwa-cpu-field-valid');
                                    inputWrap.classList.add('gwa-cpu-field-error');
                                }
                                else if (typeof errors[error] === 'string'){
                                    uploadError.innerText = errors[error];
                                }
                                else {
                                    uploadError.innerText = uploadWidgetSettings.formErrors.unknownError;
                                }
                                uploadWidget.setAttribute('data-stage', 'fill_form');
                                uploadWidget.setAttribute('data-state', 'error');
                            }
                        } else if (req.statusCode == 413 || req.status == 413 || (req.response && req.response.indexOf('Entity Too Large') !== -1)) {
                            uploadError.innerText = uploadWidgetSettings.fileErrors.sizeError;
                        } else {
                            uploadError.innerText = uploadWidgetSettings.formErrors.unknownError;
                        }
                        uploadWidget.setAttribute('data-stage', 'fill_form');
                        uploadWidget.setAttribute('data-error', 'true');
                    };

                }
            }
        });

        return CpuWidget;
    })();

    gwaCpu.Slider = (function(){
        var cpuSliderBeforeChange = new CustomEvent('cpuSliderBeforeChange');
        var cpuSliderAfterChange = new CustomEvent('cpuSliderAfterChange');
        function CpuSlider(sliderElem, options, sliderImages){
            var _this = this;
            this.cpuSlider = sliderElem;
            this.sliderTrack = this.cpuSlider.querySelector(gwaCpu.selectors.cpuSliderTrack);
            this.sliderInner = this.cpuSlider.querySelector(gwaCpu.selectors.cpuSliderInner);
            this.images = sliderImages ? sliderImages : this.cpuSlider.querySelectorAll(gwaCpu.selectors.cpuSlideImage);
            this.imagesNum = this.images.length;
            this.sliderDots = this.cpuSlider.querySelector(gwaCpu.selectors.cpuSliderDots);
            this.sliderOptions = {
                slidesToShow: 4,
                slidesToScroll: 1,
                rows: 1,
                arrows: false,
                dots: false,
                autoplay: false,
                infinite: false,
                pauseOnHover: false,
                touchMove: false,
                speed: 500,
                autoplaySpeed: 2000,
                responsive: false
            }
            if (options) {
                for (var option in options) {
                    if (this.sliderOptions.hasOwnProperty(option)){
                        this.sliderOptions[option] = options[option];
                    }
                }
            }

            this.breakpoints = [];
            if (this.sliderOptions.responsive){
                var sliderOptionsResponsive = Object.assign({}, this.sliderOptions);
                for (var bp in sliderOptionsResponsive.responsive) {
                    this.breakpoints.push(bp);
                }
                this.breakpoints = this.breakpoints.sort(function(a, b) {
                    return +a - +b;
                });
                for (var i=this.breakpoints.length - 1; i>=0; i--) {
                    for (var option in sliderOptionsResponsive) {
                        if (option === 'responsive'){
                            continue;
                        }
                        if (!sliderOptionsResponsive.responsive[this.breakpoints[i]].hasOwnProperty(option)){
                            sliderOptionsResponsive.responsive[this.breakpoints[i]][option] = sliderOptionsResponsive[option];
                        }
                        else {
                            sliderOptionsResponsive[option] = sliderOptionsResponsive.responsive[this.breakpoints[i]][option];
                        }
                    }
                }
                this.sliderOptions.responsive = Object.assign({}, sliderOptionsResponsive.responsive);
            }
            this.sliderOptionsOriginal = Object.assign({}, this.sliderOptions);

            this.windowWidth = window.innerWidth;
            this.currentBreakpoint = null;
            if (this.breakpoints.length) {
                this.checkBreakpoint();
            }

            this.slidesNum = this.slidesNumOriginal = Math.ceil(this.imagesNum / this.sliderOptions.rows);

            this.initialSlideIndex = this.currentSlideIndexOriginal = 0;
            if (this.sliderOptions.infinite && this.slidesNum > this.sliderOptions.slidesToShow){
                this.initialSlideIndex = this.sliderOptions.slidesToShow;
            }
            this.currentSlideIndex = this.initialSlideIndex;
            this.initSliderArrows();
            this.updateSliderArrows();
            this.initSlider();
            this.initAutoplay();
            this.moveOnTouch();

            window.addEventListener('resize', function(){
                if (window.innerWidth !== _this.windowWidth){
                    _this.windowWidth = window.innerWidth;
                    if (_this.breakpoints.length) {
                        _this.checkBreakpoint();
                    }
                    _this.initSlider();
                }
            });
        };
        CpuSlider.prototype = Object.assign({}, CpuSlider.prototype,{
            initSlider: function () {
                if (this.cpuSlider.offsetParent === null){
                    return;
                }
                var _this = this;

                this.slidesNumOriginal = Math.ceil(this.imagesNum / this.sliderOptions.rows);

                if (this.slidesNumOriginal <= this.sliderOptions.slidesToShow) {
                    this.sliderOptions.dots = false;
                    this.sliderOptions.arrows = false;
                    this.sliderOptions.infinite = false;
                    this.sliderOptions.autoplay = false;
                    this.sliderOptions.touchMove = false;
                }

                var allSlides = this.cpuSlider.querySelectorAll(gwaCpu.selectors.cpuSlide);
                if (allSlides.length){
                    forEachNode(allSlides, function (el){
                        el.parentNode.removeChild(el);
                    });
                }
                forEachNode(this.images, function (image, i){
                    if (i%_this.sliderOptions.rows > 0){
                        return;
                    }
                    var slide = document.createElement('div');
                    slide.classList.add(gwaCpu.selectors.cpuSlideClass);
                    slide.appendChild(image);
                    if (_this.sliderOptions.rows > 1){
                        for (var j=1;j<=_this.sliderOptions.rows && i+j < _this.imagesNum;j++){
                            slide.appendChild(_this.images[i+j]);
                        }
                    }
                    _this.sliderTrack.appendChild(slide);
                });
                var slides = this.cpuSlider.querySelectorAll(gwaCpu.selectors.cpuSlide);
                forEachNode(slides, function (el, i){
                    el.setAttribute('data-item-index', i);
                    el.setAttribute('data-item-index-original', i);
                });
                this.slidesNum = this.slidesNumOriginal;
                this.initialSlideIndex = 0;

                if (this.sliderOptions.infinite){
                    this.initialSlideIndex = this.sliderOptions.slidesToShow;
                    this.currentSlideIndex = this.currentSlideIndexOriginal + this.sliderOptions.slidesToShow;
                    for (var i=0;i<this.sliderOptions.slidesToShow;i++) {
                        var clonedEl = slides[i].cloneNode(true);
                        clonedEl.classList.add(gwaCpu.selectors.cpuSlideCloneClass);
                        this.sliderTrack.appendChild(clonedEl, slides[0]);
                    }
                    for (var i=this.slidesNum - this.sliderOptions.slidesToShow;i<this.slidesNum;i++) {
                        var clonedEl = slides[i].cloneNode(true);
                        clonedEl.classList.add(gwaCpu.selectors.cpuSlideCloneClass);
                        this.sliderTrack.insertBefore(clonedEl, slides[0]);
                    }
                    var newSlides = this.cpuSlider.querySelectorAll(gwaCpu.selectors.cpuSlide);
                    this.slidesNum = newSlides.length;
                    forEachNode(newSlides, function (el, i){
                        el.setAttribute('data-item-index', i);
                    });
                    if (this.currentSlideIndex < this.sliderOptions.slidesToShow - 1){
                        this.currentSlideIndex = this.slidesNumOriginal - 1;
                    }
                    else if (this.currentSlideIndex > this.slidesNum - this.sliderOptions.slidesToShow){
                        this.currentSlideIndex = this.initialSlideIndex;
                    }
                }
                else {
                    forEachNode(slides, function (el, i){
                        el.setAttribute('data-item-index', i);
                    });
                }

                this.sliderInnerPosition = this.sliderInner.getBoundingClientRect();
                this.sliderInnerWidth = this.sliderInnerPosition.width;
                this.slideWidth = this.sliderInnerWidth / this.sliderOptions.slidesToShow;

                this.initSliderDots();
                this.moveSlider(this.currentSlideIndex, false);
                this.startAutoplay();
            },
            initSliderArrows: function () {
                var _this = this;
                this.arrowNext = this.cpuSlider.querySelector(gwaCpu.selectors.cpuSliderArrowNext);
                this.arrowPrev = this.cpuSlider.querySelector(gwaCpu.selectors.cpuSliderArrowPrev);
                this.arrowNext.addEventListener('click', this.goToNextSlide.bind(this));
                this.arrowPrev.addEventListener('click', this.goToPrevSlide.bind(this));
            },
            updateSliderArrows: function(){
                if (!this.sliderOptions.arrows){
                    this.arrowNext.classList.add(gwaCpu.selectors.cpuSliderArrowsHiddenClass);
                    this.arrowPrev.classList.add(gwaCpu.selectors.cpuSliderArrowsHiddenClass);
                }
                else {
                    if (this.sliderOptions.infinite){
                        this.arrowNext.classList.remove(gwaCpu.selectors.cpuSliderArrowsHiddenClass);
                        this.arrowPrev.classList.remove(gwaCpu.selectors.cpuSliderArrowsHiddenClass);
                    }
                    else {
                        if (this.currentSlideIndex === 0) {
                            this.arrowPrev.classList.add(gwaCpu.selectors.cpuSliderArrowsHiddenClass);
                            this.arrowNext.classList.remove(gwaCpu.selectors.cpuSliderArrowsHiddenClass);
                        }
                        else if (this.currentSlideIndex >= this.slidesNum - this.sliderOptions.slidesToShow){
                            this.arrowNext.classList.add(gwaCpu.selectors.cpuSliderArrowsHiddenClass);
                            this.arrowPrev.classList.remove(gwaCpu.selectors.cpuSliderArrowsHiddenClass);
                        }
                        else {
                            this.arrowNext.classList.remove(gwaCpu.selectors.cpuSliderArrowsHiddenClass);
                            this.arrowPrev.classList.remove(gwaCpu.selectors.cpuSliderArrowsHiddenClass);
                        }
                    }
                }
            },
            initSliderDots: function(){
                var _this = this;
                this.sliderDots.innerHTML = '';
                if (!this.sliderOptions.dots){
                    return;
                }
                var dotsNum = Math.ceil((this.slidesNumOriginal - this.sliderOptions.slidesToShow) / this.sliderOptions.slidesToScroll) + 1;
                for (var i=0;i<dotsNum;i++) {
                    appendDot(i);
                }
                function appendDot(dotIndex){
                    var sliderDot = document.createElement('button');
                    sliderDot.setAttribute('data-item-index', _this.getSlideIndex(dotIndex*_this.sliderOptions.slidesToScroll + _this.initialSlideIndex));
                    sliderDot.classList.add(gwaCpu.selectors.cpuSliderDotClass);
                    sliderDot.innerText = dotIndex;
                    sliderDot.addEventListener('click', function(){
                        _this.moveSlider(dotIndex*_this.sliderOptions.slidesToScroll + _this.initialSlideIndex, true);
                    });
                    _this.sliderDots.appendChild(sliderDot);
                }
            },
            setActiveDot: function(){
                if (!this.sliderOptions.dots){
                    return;
                }
                var currentActiveDot = this.cpuSlider.querySelector(gwaCpu.selectors.cpuSliderDotActive);
                if (currentActiveDot) {
                    currentActiveDot.classList.remove(gwaCpu.selectors.cpuSliderDotActiveClass);
                }
                var allDots = this.sliderDots.querySelectorAll(gwaCpu.selectors.cpuSliderDot);
                if (allDots) {
                    for (var i=allDots.length - 1;i>=0;i--) {
                        if (+allDots[i].getAttribute('data-item-index') <= this.currentSlideIndex){
                            allDots[i].classList.add(gwaCpu.selectors.cpuSliderDotActiveClass);
                            break;
                        }
                    }
                }
            },
            goToNextSlide: function(){
                this.moveSlider(this.currentSlideIndex + this.sliderOptions.slidesToScroll, true);
            },
            goToPrevSlide: function(){
                this.moveSlider(this.currentSlideIndex - this.sliderOptions.slidesToScroll, true);
            },
            moveSlider: function(slideIndex, animate) {
                var _this = this;
                var nextSlideIndex = this.getSlideIndex(slideIndex);
                var currentTransform = +(getComputedStyle(this.sliderTrack).transform.split(',')[4].trim());
                var nextTransform = this.slideWidth * nextSlideIndex * -1;
                var transformLength = nextTransform - currentTransform;
                var rightTransformEdge = this.slideWidth * (this.slidesNumOriginal + this.sliderOptions.slidesToShow) * -1;
                var leftTransformEdge = 0;
                var sameSlide = this.currentSlideIndex === nextSlideIndex;

                if (!sameSlide){
                    this.cpuSlider.dispatchEvent(cpuSliderBeforeChange);
                }

                if (this.reqAnimFrame) {
                    window.cancelAnimationFrame(this.reqAnimFrame);
                }

                this.currentSlideIndex = nextSlideIndex;
                this.currentSlideIndexOriginal = this.currentSlideIndex - _this.sliderOptions.slidesToShow;

                if (animate) {
                    animateTransform();
                }
                else {
                    _this.sliderTrack.style.transform = 'translateX(' + (currentTransform + transformLength) + 'px)';
                    this.setActiveDot();
                    this.updateSliderArrows();
                }

                function easingFunction(n){
                    // return --n * n * n * n * n + 1;
                    // return --n * n * n + 1;
                    // return n * (2 - n);
                    // return 1 - Math.pow(1 - n, 4);
                    // return Math.sin(n * Math.PI / 2);
                    // return Math.sqrt(1 - (--n * n));
                    // return 1 - (--n * n * n * n);
                    // return 1 == n ? n : 1 - Math.pow(2, -10 * n);
                    // return -(Math.cos(Math.PI * n) - 1) / 2;
                    return n < 0.5 ? 2 * n * n : 1 - Math.pow(-2 * n + 2, 2) / 2;
                    // return 1 - Math.pow(1 - n, 3);
                    // return n < 0.5 ? 4 * n * n * n : 1 - Math.pow(-2 * n + 2, 3) / 2;
                    // return 1 - Math.pow(1 - n, 4);
                };
                function animateTransform(settings) {
                    var startTimestamp = null;
                    var previousValue = 0;

                    var step = function(timestamp) {
                        if (!startTimestamp) startTimestamp = timestamp;
                        var calcProgress = ((timestamp - startTimestamp) / _this.sliderOptions.speed);
                        var progress = (Math.min(easingFunction(calcProgress), 1)).toFixed(5);
                        var currentValue = progress * transformLength;
                        var transformTo = currentTransform + currentValue;

                        if (_this.sliderOptions.infinite && transformTo <= rightTransformEdge){
                            currentTransform = currentTransform + (_this.slideWidth * _this.slidesNumOriginal);
                            transformTo = currentTransform + currentValue;
                            _this.currentSlideIndex = _this.initialSlideIndex + Math.round(Math.abs(transformLength - currentValue)/_this.slideWidth);
                            _this.currentSlideIndexOriginal = _this.currentSlideIndex - _this.sliderOptions.slidesToShow;
                        }
                        else if (_this.sliderOptions.infinite && transformTo >= leftTransformEdge){
                            currentTransform = currentTransform - (_this.slideWidth * _this.slidesNumOriginal);
                            transformTo = currentTransform + currentValue;
                            _this.currentSlideIndex = _this.slidesNumOriginal - Math.round(Math.abs(transformLength - currentValue)/_this.slideWidth);
                            _this.currentSlideIndexOriginal = _this.currentSlideIndex - _this.sliderOptions.slidesToShow;
                        }
                        else if (Math.abs(currentValue) >= Math.abs(transformLength) || Math.abs(currentValue) < previousValue){
                            progress = 1;
                        }
                        previousValue = Math.abs(currentValue);
                        _this.sliderTrack.style.transform = 'translateX(' + transformTo + 'px)';
                        if (progress < 1) {
                            _this.reqAnimFrame = window.requestAnimationFrame(step);
                        }
                        else {
                            window.cancelAnimationFrame(_this.reqAnimFrame);
                            if (!sameSlide) {
                                _this.cpuSlider.dispatchEvent(cpuSliderAfterChange);
                            }
                            _this.sliderTrack.classList.remove(gwaCpu.selectors.cpuSliderTrackTransitioningClass);
                            _this.updateSliderArrows();
                            _this.setActiveDot();
                        }

                    };
                    _this.sliderTrack.classList.add(gwaCpu.selectors.cpuSliderTrackTransitioningClass);
                    _this.reqAnimFrame = window.requestAnimationFrame(step);
                }
            },
            initAutoplay: function(){
                var _this = this;

                this.sliderTrack.addEventListener("touchstart", function(){
                    clearInterval(_this.autoplayId);
                });
                this.sliderTrack.addEventListener("touchend", function(){
                    _this.startAutoplay();
                });

                if (this.sliderOptions.pauseOnHover){
                    this.cpuSlider.addEventListener('mouseenter', function(){
                        clearInterval(_this.autoplayId);
                    });
                    this.cpuSlider.addEventListener('mouseleave', function(){
                        _this.startAutoplay();
                    });
                }

                if (tabHidden !== 'undefined'){
                    document.addEventListener(visibilityChange, function(){
                        if (document.visibilityState === "hidden") {
                            clearInterval(_this.autoplayId);
                        } else  {
                            _this.initSlider();
                        }
                    }, false);
                }

            },
            startAutoplay: function(){
                clearInterval(this.autoplayId);
                if (!this.sliderOptions.autoplay){
                    return;
                }
                var _this = this;
                this.autoplayId = setInterval(function (){
                    _this.moveSlider(_this.currentSlideIndex + _this.sliderOptions.slidesToScroll, true);
                }, _this.sliderOptions.autoplaySpeed + _this.sliderOptions.speed);
            },
            moveOnTouch: function(){
                var _this = this;
                var touchData = {transform: 0, clientX: 0, numOfSlides: 0, distance: 0};
                var touchStarted = false;
                var startHandler = function (e) {
                    if (!_this.sliderOptions.touchMove){
                        return;
                    }
                    if (touchStarted) {
                        return;
                    }
                    if (e.type === 'mousedown' && e.button !== 0){
                        return;
                    }
                    if (_this.sliderTrack.className.indexOf(gwaCpu.selectors.cpuSliderTrackTransitioningClass) >=0){
                        return;
                    }
                    if (e.target.className.indexOf(gwaCpu.selectors.cpuImageZoomedClass) >= 0 || e.target.className.indexOf(gwaCpu.selectors.cpuImageZooming) >=0){
                        return;
                    }
                    e.preventDefault();
                    touchStarted = true;
                    _this.sliderTrack.style.userSelect = 'none';
                    var currentTransform = +(getComputedStyle(_this.sliderTrack).transform.split(',')[4].trim());
                    touchData = {
                        transform: currentTransform,
                        clientX: e.type === 'touchstart' ? e.touches[0].clientX : e.clientX,
                        numOfSlides: 0,
                        distance: 0
                    };

                    _this.sliderTrack.addEventListener('mousemove', moveHandler);
                    _this.sliderTrack.addEventListener('mouseup', endHandler);
                    _this.sliderTrack.addEventListener("mouseleave", endHandler);

                    _this.sliderTrack.addEventListener("touchmove", moveHandler);
                    _this.sliderTrack.addEventListener("touchend", endHandler);
                };

                var moveHandler = function (e) {
                    e.preventDefault();
                    var distance = (e.type === 'touchmove' ? e.touches[0].clientX : e.clientX) - touchData.clientX;
                    touchData.distance = distance;
                    _this.sliderTrack.style.transform = 'translateX(' + (touchData.transform + distance) + 'px)';
                    touchData.numOfSlides = Math.ceil(Math.abs(distance) / _this.slideWidth / _this.sliderOptions.slidesToScroll);
                    if (distance > 0) {
                        touchData.numOfSlides = touchData.numOfSlides * -1
                    }
                };

                var endHandler = function (e) {
                    _this.sliderTrack.style.removeProperty('user-select');
                    if (Math.abs(touchData.distance) > 20){
                        _this.moveSlider(_this.currentSlideIndex + touchData.numOfSlides*_this.sliderOptions.slidesToScroll, true);
                    }
                    else {
                        _this.moveSlider(_this.currentSlideIndex, true);
                    }
                    _this.sliderTrack.removeEventListener('mousemove', moveHandler);
                    _this.sliderTrack.removeEventListener('mouseup', endHandler);
                    _this.sliderTrack.removeEventListener("mouseleave", endHandler);

                    _this.sliderTrack.removeEventListener("touchmove", moveHandler);
                    _this.sliderTrack.removeEventListener("touchend", endHandler);
                    touchStarted = false;
                };

                this.sliderTrack.addEventListener('mousedown', startHandler);
                this.sliderTrack.addEventListener("touchstart", startHandler);
            },
            getSlideIndex: function (slideIndex){
                if (this.slidesNum <= this.sliderOptions.slidesToShow) {
                    return this.initialSlideIndex;
                }
                if (this.sliderOptions.infinite){
                    return slideIndex;
                }
                if (slideIndex < this.initialSlideIndex || this.slidesNum < this.sliderOptions.slidesToShow) {
                    return this.initialSlideIndex;
                }
                var calcSlideIndex = slideIndex;
                if (slideIndex % this.sliderOptions.slidesToScroll > 0) {
                    calcSlideIndex = Math.ceil(slideIndex / this.sliderOptions.slidesToScroll) * this.sliderOptions.slidesToScroll;
                }
                return Math.min(calcSlideIndex, this.slidesNum - this.sliderOptions.slidesToShow);
            },
            checkBreakpoint: function (){
                if (!this.breakpoints.length) {
                    return;
                }
                var breakpoint = null;
                for (var i=0; i<this.breakpoints.length; i++) {
                    if (this.windowWidth <= this.breakpoints[i]){
                        breakpoint = this.breakpoints[i];
                        break;
                    }
                }
                if (this.currentBreakpoint !== breakpoint) {
                    this.currentBreakpoint = breakpoint;
                    if (this.currentBreakpoint) {
                        this.sliderOptions = Object.assign({}, this.sliderOptionsOriginal.responsive[breakpoint]);
                    }
                    else {
                        this.sliderOptions = Object.assign({}, this.sliderOptionsOriginal);
                    }
                }
            }
        });
        return CpuSlider;
    })();

    gwaCpu.initWidget = function () {
        var cpuWidgets = document.querySelectorAll(gwaCpu.selectors.cpuWidget);
        if (cpuWidgets.length) {
            cpuWidgetInited = true;
            if (cpuWidgets[0].getAttribute('data-cpu-styles')) {
                var widgetStyleLink = document.createElement('link');
                widgetStyleLink.type = 'text/css';
                widgetStyleLink.rel = 'stylesheet';
                widgetStyleLink.href = cpuWidgets[0].getAttribute('data-cpu-styles');
                document.getElementsByTagName('head')[0].appendChild(widgetStyleLink);
            }
            var widgetSections = [];

            forEachNode(cpuWidgets, function(cpuWidget){
                var newCpuWidget = new gwaCpu.Widget(cpuWidget);
                widgetSections.push(newCpuWidget.widgetSectionId);
            });

            document.addEventListener("shopify:section:load", function(e){
                if (e.target.classList.contains(gwaCpu.selectors.cpuSectionClass) && e.detail.sectionId.indexOf(widgetSections) === -1){
                    var newCpuWidget = new gwaCpu.Widget(e.target.querySelector(gwaCpu.selectors.cpuWidget));
                    widgetSections.push(newCpuWidget.widgetSectionId);
                }
                else if (e.target.querySelector(gwaCpu.selectors.cpuWidget)) {
                    e.target.querySelectorAll(gwaCpu.selectors.cpuWidget).forEach(function () {
                        var newCpuWidget = new gwaCpu.Widget(this);
                    })
                }
            });
        }
    };

    gwaCpu.initWidget();
    window.addEventListener('DOMContentLoaded', function(event) {
        if (cpuWidgetInited){
            return;
        }
        else {
            gwaCpu.initWidget();
        }
    });
    document.addEventListener("shopify:section:load", function(e){
        if (cpuWidgetInited){
            return;
        }
        else if (e.target.classList.contains(gwaCpu.selectors.cpuSectionClass)) {
            gwaCpu.initWidget();
        }
    });
})();